/**
 *
 * Asynchronously loads the component for AllReports
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AllReports = lazyLoad(
  // @ts-ignore
  () => import('./index.tsx'),
  module => module.AllReports,
);
